<template>
    <v-dialog
            scrollable
            v-model="visible"
            max-width="1200px"
            :fullscreen="fullscreen"
            :persistent="true"
    >
        <v-card class="main-content-card" flat id="proj-index-card">
            <v-toolbar flat>
                <v-toolbar-title>科研项目</v-toolbar-title>
            </v-toolbar>

            <v-divider/>

            <!-- 检索功能区 -->
            <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
                <v-layout row wrap>
                    <v-flex d-flex xs10>
                        <v-layout row wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        label="项目名称"
                                        v-model="form.name"
                                        :clearable="true"
                                        hide-details/>
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-text-field
                                        label="归属部门"
                                        v-model="form.deptName"
                                        readonly
                                        :menu-props="{maxHeight:450}"/>
                            </v-flex>

                            <v-flex xs12 sm2>
                                <v-text-field
                                        label="项目负责人"
                                        v-model="form.leaderName"
                                        :clearable="true"
                                        readonly
                                        hide-details/>
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-menu
                                        ref="refEntryDateStart"
                                        :close-on-content-click="false"
                                        v-model="menuEntryDateStart"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px">
                                    <v-text-field
                                            slot="activator"
                                            v-model="form.entryDateStart"
                                            label="立项时间(起始)"
                                            :rules="rules.startDate"
                                            hint="格式YYYY-MM-DD, 如：2018-10-01"
                                            persistent-hint/>
                                    <v-date-picker
                                            v-model="entryDateStart"
                                            locale="zh-cn"
                                            @change="nv => form.entryDateStart= nv"
                                    />
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-menu
                                        ref="refEntryDateEnd"
                                        :close-on-content-click="false"
                                        v-model="menuEntryDateEnd"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px">
                                    <v-text-field
                                            slot="activator"
                                            v-model="form.entryDateEnd"
                                            label="立项时间(截止)"
                                            :rules="rules.endDate"
                                            hint="格式YYYY-MM-DD, 如：2018-10-01"
                                            persistent-hint
                                    />
                                    <v-date-picker
                                            v-model="entryDateEnd"
                                            locale="zh-cn"
                                            @change="nv => form.entryDateEnd= nv"
                                    />
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <proj-tpe-tree v-model="form.types"/>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex d-flex xs2 text-xs-center>
                        <div>
                            <v-btn color="primary" @click="onSearch">
                                <v-icon dark>search</v-icon>
                                检索
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-divider/>

            <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="items"
                    item-key="dbid"
                    hide-actions
                    select-all
            >
                <template slot="items" slot-scope="props">
                    <td>
                        <v-checkbox
                                v-model="props.selected"
                                primary
                                hide-details
                        ></v-checkbox>
                    </td>
                    <td>
                        {{ props.index + 1}}
                    </td>
                    <td class="text-xs-center">{{props.item.name}}</td>
                    <td class="text-xs-center">{{props.item.number}}</td>
                    <td class="text-xs-center">{{props.item.entryDate}}</td>
                    <td class="text-xs-center">{{props.item.startDate}}</td>
                    <td class="text-xs-center">{{props.item.finishDate}}</td>
                    <td class="text-xs-center">{{props.item.projStatus.name}}</td>
                    <td class="text-xs-center">{{props.item.department.name}}</td>
                    <td class="text-xs-center">{{props.item.adminDept.name}}</td>
                    <td class="text-xs-center">{{props.item.contractAmounts}}</td>
                </template>
            </v-data-table>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
                <v-btn color="primary" @click.native="onSave(selected)">保存
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import ProjTpeTree from './ProjTpeTree'
    const projUri = '/api/proj/project';
    const deptUri = '/api/syst/department';
    const typeUri = '/api/proj/project-type/flatten/tree';
    const baseUri = '/api/integrity/integrity';

    export default {
        props: ['value','dbid','deptName','deptId','uName'],
        components: {ProjTpeTree},
        data() {
            return {
                formValid: false,
                // 检索、分页、排序条件条件
                selected: [],
                query: {
                    name: '',
                    leaderName: '',
                    entryDateStart: '',
                    entryDateEnd: '',
                    deptId: '',
                    types: []
                },

                form: {
                    name: '',
                    leaderName: '',
                    number: '',
                    entryDateStart: '',
                    entryDateEnd: '',
                    deptId: '',
                    types: []
                },

                deptItems: [],
                typeItems: [],

                menuEntryDateStart: false,
                entryDateStart: null,

                menuEntryDateEnd: false,
                entryDateEnd: null,
                addDbid: null,

                // 表头
                headers: [
                    {text: '#', align: 'left', sortable: false, value: 'dbid', width: "20"},
                    {text: '项目名称', align: 'left', value: 'name', sortable: false, width: 200},
                    {text: '项目编号', align: 'left', value: 'number', sortable: false, width: 20},
                    {text: '立项时间', align: 'left', value: 'entryDate', sortable: false, width: 20},
                    {text: '项目开始时间', align: 'left', value: 'startDate', sortable: false, width: 20},
                    {text: '项目截止时间', align: 'left', value: 'finishDate', sortable: false, width: 20},
                    {text: '项目状态', align: 'left', value: 'status', sortable: false, width: 40},
                    {text: '项目所属部门', align: 'left', value: 'deptName', sortable: false, width: 120},
                    {text: '项目主管部门', align: 'left', value: 'adminDept', sortable: false, width: 120},
                    {text: '合同金额(元)', align: 'left', value: 'contractAmounts', sortable: false, width: 60}
                ],
                items: [],
                fullscreen: false,

                /**
                 * 验证规则
                 */
                rules: {}
            }
        },
        computed: {
            visible: {
                // getter
                get: function () {
                    return this.value;
                },
                // setter
                set: function (nv) {
                    this.$emit('input', nv);
                }
            }
        },

        beforeMount() {
            this.axios.all([
                this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
                this.axios.get(typeUri)
            ]).then(
                this.axios.spread(
                    (rspDept, rspType) => {
                        this.deptItems = rspDept.data.items;
                        this.typeItems = rspType.data.reduce(
                            (acc, v, i) => {
                                if (!v.leaf) {
                                    if (i > 0)
                                        acc.push({divider: true}, {header: v.name});
                                    else
                                        acc.push({header: v.name});
                                } else {
                                    acc.push(v);
                                }
                                return acc;
                            }, []);
                    }
                )
            )
        },

        watch: {
            dbid(v) {
                if (!v) {
                    this.dbid && this.dbid.length > 0 && this.get();
                }
            },
            deptId(v){
                if (!v) {
                    this.deptId && this.deptId.length > 0 && this.get();
                }
            },
            deptName(v){
                 this.form.deptName =v;
            },
            uName(v){
                this.form.leaderName =v;
            }
        },

        methods: {
            // 检索响应函数
            onSearch() {
                window.console.log(JSON.stringify(this.query));
                const vm = this;
                const params = Object.assign(
                    window.xutil.param("name", this.form.name),
                    window.xutil.param("leaderName", this.form.leaderName),
                    window.xutil.param("entryDateStart", this.form.entryDateStart),
                    window.xutil.param("entryDateEnd", this.form.entryDateEnd),
                    window.xutil.param("deptId", this.deptId),
                    window.xutil.param("statusId","checked"),
                    window.xutil.param("types", this.form.types.join(","))
                );
                console.log(params);
                vm.loading = true;
                this.axios.get(`${projUri}?limit=500`, {params: params})
                    .then(rsp => {
                        vm.loading = false;
                        vm.items = rsp.data.items;
                    })
            },
            // 保存响应函数
            onSave(selected) {
                const vm = this;
                this.loading = true;
                 console.log(this.dbid);
                this.axios.put(`${baseUri}/proj/${this.dbid}`, selected.map(it => {
                    return {"projName": it.name, "number": it.number, "entryDate": it.entryDate, "startDate": it.startDate,"finishDate":it.finishDate,"status":it.projStatus.name,"deptName":it.department.name,"adminDept":it.adminDept.name,"contractAmounts":it.contractAmounts}
                }))
                    .then(rsp => {
                        vm.$emit('ok', rsp.data.items);
                        vm.$emit('input', false);
                        vm.loading = false;
                        vm.visible = false;
                    });
            }
        }
    }
</script>
